import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { overrideCSS, isNullOrUndefined, addItemToGoogleTracking } from '../../utils';
let FaAngleDown = require('react-icons/lib/fa/angle-down');
import { ISorting, IAppParams } from "../../models";

const styles = require('./FilterSelector.pcss');
const internalStyles = require('./FilterSelector.pcss');

/*-------- Interfaces ---------*/

interface IProps {
    type: string;
    options?: string[];
    sorting?: ISorting;
    changeSortOrder?: any;
    appParams?: IAppParams;
    styles?: Object;
}

interface IState {
    visible: boolean;
}

/*-------- Component ---------*/
let body = document.querySelector("body");

export class FilterSelector extends React.Component<IProps, IState>{

    constructor(props) {
        super(props);

        this.state = { visible: false };
        // this.showDropdown = this.showDropdown.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleSelection = this.handleSelection.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
    }


    handleSelection(sortOrder) {
        let { changeSortOrder, appParams } = this.props;
        this.toggleDropdown();
        addItemToGoogleTracking(appParams, "fund_explorer_sort", { eventLabel: "Sort Explorer" });
        changeSortOrder(sortOrder, appParams);
    }

    toggleDropdown(event?) {
        let currentVisibility = this.state.visible;
        this.setState({ visible: !currentVisibility }, () => {
            this.handleProps();
        });
    }

    componentWillMount() {
        this.handleProps();
    }

    handleProps() {
        if (this.state.visible) {
            this.addEvents();
        } else {
            this.removeEvents();
        }
    }

    addEvents() {
        document.addEventListener('click', this.handleDocumentClick, true);
    }

    removeEvents() {
        document.removeEventListener('click', this.handleDocumentClick, true);
    }

    handleDocumentClick(e) {
        const container = ReactDOM.findDOMNode(this);

        if (container.contains(e.target) && container !== e.target) {
            return;
        }

        this.toggleDropdown(e);
    }

    // hideDropdown() {
    //     this.setState({ visible: false });
    // }

    // showDropdown() {
    //     let currentVisibility = this.state.visible;
    //     this.setState({ visible: !currentVisibility });
    // }

    render() {
        let stylesComposed = this.props.styles ? overrideCSS(internalStyles, this.props.styles) : internalStyles;
        let { type, sorting } = this.props;
        if (isNullOrUndefined(sorting)) {
            return <div></div>;
        }
        let visibility = this.state.visible ? styles.active : '';
        let internalClasses = {
            dropdown: `${stylesComposed.dropdown} ${visibility}`,
            arrow: `${stylesComposed.arrow} ${visibility}`
        };

        return (
            <div className={stylesComposed.selector}>
                <div className={stylesComposed.filterTitle} onClick={this.toggleDropdown}>

                    {type}<FaAngleDown />
                </div>

                <section className={internalClasses.dropdown}>
                    <div className={stylesComposed.options}>
                        <ul>
                            {(() => {
                                if (sorting.sortOrder === "ASC") {
                                    return <li onClick={() => this.handleSelection('DESC')}>Fund name Z-A</li>;
                                }
                                else {
                                    return <li onClick={() => this.handleSelection('ASC')}>Fund name A-Z</li>;
                                }
                            })()}
                        </ul>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/FilterSelector/FilterSelector.tsx